export default {
  namespaced: true,
  state: {
    versementSelectionne: [],
  },
  mutations: {
    SET_VERSEMENTS_SELECTIONNE(state, _versements) {
      state.versementSelectionne = _versements
    },
  },
  getters: {
    estEnSelection: (state) => state.versementSelectionne.length > 0,
    getVersementSelectionne: (state) => state.versementSelectionne,
    getVersementsSelectionnesParServices: (state) => {
      if (state.versementSelectionne.length === 0) {
        return []
      }
      let versementsParServices = []
      let serviceIndex = -1
      let usagerIndex = -1
      state.versementSelectionne.forEach((v) => {
        serviceIndex = versementsParServices.findIndex(
          (s) => s.service.serviceId === v.accueil.serviceDAccueil.serviceId
        )
        if (serviceIndex === -1) {
          versementsParServices.push({
            service: v.accueil.serviceDAccueil,
            usagers: [],
            montantTotalEspece: 0.0,
            montantTotalVirement: 0.0,
          })
          serviceIndex = versementsParServices.length - 1
        }

        usagerIndex = versementsParServices[serviceIndex].usagers.findIndex(
          (u) => u.usager.usagerId === v.accueil.usagerAccueilli.usagerId
        )
        if (usagerIndex === -1) {
          versementsParServices[serviceIndex].usagers.push({
            usager: v.accueil.usagerAccueilli,
            montantTotalEspece: 0.0,
            versementsEspece: [],
            montantTotalVirement: 0.0,
            versementsVirement: [],
          })
          usagerIndex = versementsParServices[serviceIndex].usagers.length - 1
        }

        if (v.moyenDePaiement.moyenDePaiementId === 'ESPECE') {
          versementsParServices[serviceIndex].usagers[usagerIndex].versementsEspece.push(v)
          versementsParServices[serviceIndex].montantTotalEspece += v.montant
          versementsParServices[serviceIndex].usagers[usagerIndex].montantTotalEspece += v.montant
        } else if (v.moyenDePaiement.moyenDePaiementId === 'VIREMENT') {
          versementsParServices[serviceIndex].usagers[usagerIndex].versementsVirement.push(v)
          versementsParServices[serviceIndex].usagers[usagerIndex].montantTotalVirement += v.montant
          versementsParServices[serviceIndex].montantTotalVirement += v.montant
        } else {
          console.error('Impossible de trier le versemant avec le moyen de paiement : ', v.moyenDePaiement)
        }
      })
      return versementsParServices
    },
  },
  actions: {
    async setVersementsSelectionne({ commit }, _versements) {
      commit('SET_VERSEMENTS_SELECTIONNE', _versements)
    },
  },
}
